export default __webpack_public_path__ + "static/media/aircond2.51adc745.png";